// Právní subjekty (firmy) — data a migrace.
// (Krok B1b: rozděleno ze src/app.js beze změny kódu; importy/exporty doplněny automaticky.)
import { appearance } from './appearance.js';
import { ICONS, ROLE_LABELS, SCOPE_MODES, SCOPE_PAGES, canManageContent, canWriteAudits, currentCompany, esc, isCompanyAccessible, queueWrite, realRole, saveCurrentCompanyId, saveScope, sortedCompanies, state } from './state.js';
import { db } from './boot.js';
import { myNavBadgeCounts } from '../views/my-tasks.js';
import { render } from '../main-render.js';
import { isReadOnly } from './licence.js';

// ---------- právní subjekty (companies) ----------
function ensureCurrentCompanySelected(){
  if(state.companies.size===0){ return; }
  // Checked against isCompanyAccessible, not state.companies.has(), so a
  // stale currentCompanyId (from localStorage, or from access that's since
  // been revoked) never keeps pointing at a subjekt the person can no
  // longer see.
  if(state.currentCompanyId && state.companies.has(state.currentCompanyId) && isCompanyAccessible(state.currentCompanyId)) return;
  var first = sortedCompanies()[0];
  if(!first){ state.currentCompanyId=''; return; }
  state.currentCompanyId = first[0];
  saveCurrentCompanyId(state.currentCompanyId);
}
var companyMigrationAttempted = false;
var KMEN_FROM_PORTAL = true;
function maybeMigrateCompanies(){
  // Firmy zakládá jen portál (fáze 2 ekosystému, 2026-11-02) — Audit už
  // sám žádnou firmu nevytváří. Původní převod ze starého brandingu zůstává
  // vypnutý pro případ obnovy.
  if(KMEN_FROM_PORTAL) return;
  if(companyMigrationAttempted) return;
  if(!db) return;
  if(!(state.ready.companies && state.ready.workplaces && state.ready.branches && state.ready.audits && state.ready.branding)) return;
  companyMigrationAttempted = true;
  if(state.companies.size>0) return; // already have at least one legal entity -> nothing to backfill
  if(!canManageContent()) return; // only an admin/správce session can write the migration; others simply skip it
  if(isReadOnly()) return; // licence: jen ke čtení
  var b = state.branding || {};
  var companyData = {
    name: b.companyName || 'Moje firma', ico: b.ico||'', address: b.address||'',
    logoAssetId: b.logoAssetId||'', logoUrl: b.logoUrl||'', logoHeight: b.logoHeight||32,
    order: 0, createdAt: new Date().toISOString()
  };
  queueWrite(function(){
    return db.collection('companies').add(companyData).then(function(ref){
      var companyId = ref.id;
      var writes = [];
      state.workplaces.forEach(function(w, id){ if(!w.companyId) writes.push(db.doc('workplaces/'+id).update({companyId:companyId})); });
      state.branches.forEach(function(br, id){ if(!br.companyId) writes.push(db.doc('branches/'+id).update({companyId:companyId})); });
      state.audits.forEach(function(a, id){ if(!a.companyId) writes.push(db.doc('audits/'+id).update({companyId:companyId})); });
      return Promise.all(writes).then(function(){
        state.currentCompanyId = companyId;
        saveCurrentCompanyId(companyId);
        render();
      });
    });
  }).catch(function(e){ console.error('company migration failed', e); companyMigrationAttempted = false; });
}
// Jednorázové zpětné doplnění auditNumber u auditů, které vznikly před
// zavedením číslování (viz nextAuditNumberForCompany výše) — jinak by
// stará historie zůstala bez čísla. Řadí se chronologicky (uzavřené podle
// closedAt, rozpracované podle startedAt) a číslují se zvlášť za každou
// firmu od 1, stejně jako nová čísla při zakládání auditu.
var auditNumberMigrationAttempted = false;
function maybeMigrateAuditNumbers(){
  if(auditNumberMigrationAttempted) return;
  if(!db) return;
  if(!state.ready.audits) return;
  auditNumberMigrationAttempted = true;
  if(!canManageContent()) return; // zápis migrace dělá jen admin/správce session
  if(isReadOnly()) return; // licence: jen ke čtení
  var missing = Array.from(state.audits.entries()).filter(function(e){ return !e[1].auditNumber; });
  if(missing.length===0) return;
  missing.sort(function(a,b){
    var ta = new Date(a[1].closedAt || a[1].startedAt || 0).getTime();
    var tb = new Date(b[1].closedAt || b[1].startedAt || 0).getTime();
    return ta-tb;
  });
  var counters = {};
  state.audits.forEach(function(a){
    if(a.auditNumber && !a.auditCode){ var cid = a.companyId||''; counters[cid] = Math.max(counters[cid]||0, a.auditNumber); }
  });
  var writes = [];
  missing.forEach(function(e){
    var id=e[0], a=e[1];
    var cid = a.companyId||'';
    var num = (counters[cid]||0)+1;
    counters[cid] = num;
    a.auditNumber = num; // promítnout do lokálního stavu hned, ať se číslo zobrazí bez čekání na refetch
    writes.push(db.doc('audits/'+id).update({auditNumber:num}));
  });
  queueWrite(function(){ return Promise.all(writes); }).catch(function(e){ console.error('audit number migration failed', e); auditNumberMigrationAttempted = false; });
}

// Záhlaví vlevo nahoře je teď záměrně jen logo + název firmy (+ přepínač
// firem) — jméno uživatele, role a počet rozpracovaných auditů se dřív
// zobrazovaly tady jako doplňkový řádek, ale to je dostupné i jinde (role
// v profilu, rozpracované audity na dashboardu), takže tu zbytečně dělalo
// nepořádek. Prvek zůstává v DOM jen pro skutečně důležitá hlášení (např.
// ztráta přístupu k datům) — jinak je skrytý.
function updateTopbarSub(){
  var el = document.getElementById('topbarSub');
  if(!el) return;
  if(state.dbMissing){
    el.textContent = 'Bez přístupu k datům';
    el.style.display = '';
  } else {
    el.textContent = '';
    el.style.display = 'none';
  }
}
var DEFAULT_MARK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3 8-8"/><path d="M20 12v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h9"/></svg>';
function updateBrandingHeader(){
  var mark = document.getElementById('topbarMark');
  var title = document.getElementById('topbarTitle');
  // Once at least one legal entity exists, the header reflects the currently
  // active one; the old global branding doc is only a fallback before the
  // one-time migration has created that first company.
  var c = currentCompany();
  var b = c || state.branding || {};
  if(mark){
    var hasLogo = b.logoUrl;
    mark.classList.toggle('logo-mode', !!hasLogo);
    if(hasLogo){
      mark.style.setProperty('--logo-h', (b.logoHeight||32)+'px');
      mark.innerHTML = '<img src="'+esc(b.logoUrl)+'" alt="Logo"/>';
    } else {
      mark.style.removeProperty('--logo-h');
      mark.innerHTML = DEFAULT_MARK_SVG;
    }
  }
  updateCompanySwitcherButton();
}
// Záhlaví vedle loga: jen název aktivního subjektu (rozhodnutí uživatele);
// při více subjektech je název zároveň tlačítkem pro přepnutí subjektu
// (malá šipka ▾), stejným písmem. Bez subjektu název appky „Audit“.
var APP_NAME = window.APP_NAME || 'Audit';
function updateCompanySwitcherButton(){
  var title = document.getElementById('topbarTitle');
  if(!title) return;
  var c = currentCompany();
  var name = c ? (c.name||'(bez názvu)') : ((state.branding && state.branding.companyName) || '');
  if(state.companies.size>=2){
    title.innerHTML = '<button type="button" class="topbar-title-btn" onclick="App.openCompanySwitcher()" aria-label="Přepnout subjekt">' +
      '<span>'+esc(name || 'Vybrat subjekt')+'</span>' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 10l5 5 5-5"/></svg></button>';
    title.title = (name || 'Vybrat subjekt') + ' · přepnout subjekt';
  } else {
    title.textContent = name || APP_NAME;
    title.title = name ? name + ' · ' + APP_NAME : APP_NAME;
  }
}
function updatePreviewBanner(){
  var el = document.getElementById('previewBanner');
  if(!el) return;
  if(realRole()==='administrator' && state.viewAsRole && state.viewAsRole!=='administrator'){
    el.style.display = 'flex';
    el.innerHTML = '<span>Náhled aplikace jako role: <b>'+esc(ROLE_LABELS[state.viewAsRole]||state.viewAsRole)+'</b></span>' +
      '<button class="btn btn-sm" onclick="App.setViewAsRole(\'administrator\')">Zpět</button>';
  } else {
    el.style.display = 'none';
    el.innerHTML = '';
  }
}
window.App = window.App || {};
var SCOPE_PAGE_KEY = {history:'historyPage', corrective:'correctivePage', schedule:'schedulePage'};
function setScopeSilent(pg, mode){
  if(SCOPE_MODES.indexOf(mode)<0) return;
  state.scope[pg] = mode;
  saveScope(pg, mode);
  // Stránkování seznamu začne znovu od první stránky.
  if(SCOPE_PAGE_KEY[pg]) state[SCOPE_PAGE_KEY[pg]] = 1;
}
App.setScope = function(pg, mode){ setScopeSilent(pg, mode); render(); };
// Všechny stránky najednou (Moje / Vše) — kvůli testům a starším odkazům.
App.setScopeAll = function(all){
  SCOPE_PAGES.forEach(function(pg){ setScopeSilent(pg, all?'all':'mine'); });
  render();
};
App.setViewAsRole = function(role){
  if(realRole()!=='administrator') return;
  state.viewAsRole = (role==='administrator') ? null : role;
  state.view = 'dashboard';
  render();
};
var SETTINGS_VIEWS = ['settings','questions','users','companyAccess','profile','branding','appearance','dashboardSettings','scoreSettings','scheduleStartSettings','notificationSettings','calendarSync','auditRules','scheduleManage','companies','auditorGroups','feedbackNew','myFeedback','feedbackAdmin','contactOperator'];
// Dok / boční lišta: Přehled, Audity, Opatření, Plán (rozhodnutí uživatele
// 2026-10-28). „Audity“ = rozpracované, k zahájení a uzavřené (dřívější
// Audit + Historie); položka je aktivní na všech obrazovkách ze `views`.
function navTabsForRole(){
  var tabs = [
    {id:'dashboard', views:['dashboard','stats'], label:'Přehled', icon:ICONS.navDashboard}
  ];
  var nb = myNavBadgeCounts();
  if(canWriteAudits()) tabs.push({id:'audit', views:['audit','history','workplace'], label:'Audity', icon:ICONS.navAudit, badge:nb.audit, onclick:'App.openAudits()'});
  else tabs.push({id:'history', views:['history','workplace'], label:'Audity', icon:ICONS.navAudit});
  tabs.push({id:'corrective', views:['corrective'], label:'Opatření', icon:ICONS.navCorrective, badge:nb.corrective});
  tabs.push({id:'schedule', views:['schedule'], label:'Plán', icon:ICONS.navSchedule});
  return tabs;
}
function renderNav(){
  var bar = document.getElementById('tabbar');
  if(!bar) return;
  var tabs = navTabsForRole();
  bar.style.gridTemplateColumns = 'repeat(' + tabs.length + ',1fr)';
  var showBadges = appearance.navBadges!==false;
  bar.innerHTML = tabs.map(function(t){
    var active = t.views.indexOf(state.view)>=0;
    return '<button class="tab'+(active?' active':'')+'" data-view="'+t.id+'" title="'+esc(t.label)+'" onclick="'+(t.onclick || 'App.setView(\''+t.id+'\')')+'">' +
      '<span class="dot">'+t.icon+(showBadges && t.badge>0?'<span class="badge-dot">'+t.badge+'</span>':'')+'</span>' +
      '<span class="tab-label">'+t.label+'</span></button>';
  }).join('');
  var allViews = tabs.reduce(function(a, t){ return a.concat(t.views); }, []).concat(SETTINGS_VIEWS);
  if(allViews.indexOf(state.view)<0){
    state.view = 'dashboard';
  }
}

export {
  ensureCurrentCompanySelected,
  maybeMigrateAuditNumbers,
  maybeMigrateCompanies,
  renderNav,
  setScopeSilent,
  updateBrandingHeader,
  updateCompanySwitcherButton,
  updatePreviewBanner,
  updateTopbarSub
};
